import { MAX_CHARGE_DAYS } from "@/lib/constant";
import { PriceResultAllExtra } from "@/lib/type";

export const extraTotalWithRentalDays = (
  extras: PriceResultAllExtra[],
  rentalDays: number
): number => {
  return extras.reduce((acc, extra) => {
    // const maxDays = MAX_CHARGE_DAYS[extra.extra_id.toUpperCase()] || rentalDays;
    // const cappedDays = Math.min(rentalDays, maxDays);
    const extraValue =
      (extra.value / 100) *
      (100 + extra.tax_rate) *
      (rentalDays || 0) *
      (extra.count || 0);

    return acc + extraValue;
  }, 0);
};

export const extraTotalWithCountOnly = (
  extras: PriceResultAllExtra[]
): number => {
  return extras.reduce((acc, extra) => {
    const extraValue =
      (extra.value / 100) * (100 + extra.tax_rate) * (extra.count || 0); // Use count only, no rental days involved

    return acc + extraValue;
  }, 0);
};
